import { createStore } from 'vuex';
const store = createStore({
  state () {
    return {
      loaded: false,
      user: {},
      wishlist: [],
      products: [
        {
          spu_id: 0,
          brand_name: "null",
          price: 0,
          logo_url: "null",
          title: "null"
        }
      ],
      product: {
        favoriteData: {
          favoriteCount: {
            count: 0
          }
        },
        detail: {
          articleNumber: "null",
          title: "null"
        },
        saleProperties: {
          list: []
        },
        shareInfo: {
          shareLinkUrl: "null"
        },
        price: {
          item: {
            price: 0
          }
        },
        image: {
          spuImage: {
            images: []
          }
        }
      }
    }
  },
  mutations: {
    setStateProperty(state, { property, value }) {
      state[property] = value;
    },
  },
  getters: {
    doneTodos (state) {
      return state.tex.filter(todo => todo.done)
    }
  }
});

export default store;

